import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import CMSGallery from "../components/CMSGallery";
import { IMAGES, HOVTRIM_TEXT } from "../data/content";

export default function Hovtrim() {
  return (
    <>
      <SEO
        title="Naturlig hovtrimning"
        description="Læs om naturlig hovtrimning efter Jaime Jacksons vildhestemodel. Se de 4 guidelines for et naturligt trim og afbalancering af hestens hove hos Hoofcare."
      />

      {/* Header Banner */}
      <section className="bg-forest-900 text-white py-14 lg:py-18 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img
            src={IMAGES.trimming.replace("assets.auxodev.dk/", "assets.auxodev.dk/cdn-cgi/image/width=1600,format=auto,quality=80/")}
            alt="Hovtrim baggrund"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-3">
          <span className="text-xs font-bold uppercase tracking-wider text-emerald-400">
            Hovpleje & Biomekanik
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-sand-50">
            Hovtrim
          </h1>
          <p className="text-sand-200 max-w-2xl text-base leading-relaxed">
            {HOVTRIM_TEXT.title}
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-sand-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
            <div className="md:col-span-7 space-y-5">
              <h2 className="text-2xl sm:text-3xl font-bold text-forest-900 leading-snug">
                {HOVTRIM_TEXT.title}
              </h2>
              
              <p className="text-charcoal-700 leading-relaxed text-base">
                {HOVTRIM_TEXT.intro}
              </p>

              {/* Guidelines Box */}
              <div className="bg-white p-6 sm:p-7 rounded-2xl border border-sand-300 shadow-xs space-y-4">
                <h3 className="text-base sm:text-lg font-bold text-forest-900 flex items-center gap-2">
                  <i className="fa-solid fa-list-check text-emerald-700"></i>
                  {HOVTRIM_TEXT.guidelinesTitle}
                </h3>

                <ul className="space-y-3 text-sm text-charcoal-800">
                  {HOVTRIM_TEXT.guidelines.map((g, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <span className="w-5 h-5 rounded-full bg-forest-100 text-forest-800 flex items-center justify-center text-xs font-bold shrink-0 mt-0.5">
                        {idx + 1}
                      </span>
                      <span>{g}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <p className="text-charcoal-700 leading-relaxed text-base">
                {HOVTRIM_TEXT.p1}
              </p>

              <p className="text-charcoal-700 leading-relaxed text-base">
                {HOVTRIM_TEXT.p2}
              </p>

              <p className="text-charcoal-700 leading-relaxed text-base">
                {HOVTRIM_TEXT.p3}
              </p>
            </div>

            <div className="md:col-span-5 space-y-6">
              <div className="rounded-2xl overflow-hidden border border-sand-300 shadow-md">
                <img
                  src={IMAGES.trimming.replace("assets.auxodev.dk/", "assets.auxodev.dk/cdn-cgi/image/width=800,format=auto,quality=80/")}
                  alt="Naturlig hovtrimning i stald"
                  className="w-full h-auto object-cover"
                />
              </div>

              <div className="bg-sand-100 p-6 rounded-2xl border border-sand-300 space-y-3">
                <h4 className="font-bold text-forest-900 text-sm flex items-center gap-2">
                  <i className="fa-solid fa-heart-pulse text-emerald-700"></i>
                  Respect the healing power of nature
                </h4>
                <p className="text-xs text-charcoal-700 leading-relaxed">
                  Gennem hyppige trim og naturlig afbalancering får hoven muligheden for selv at heale og genskabe sin optimale form.
                </p>
              </div>
            </div>
          </div>

          {/* CMS Galleri */}
          <div className="pt-6 border-t border-sand-300">
            <CMSGallery gallerySlug="hovtrim" title="Galleri: Eksempler på Hovtrim" />
          </div>

          {/* CTA Box */}
          <div className="bg-forest-900 text-white p-8 rounded-2xl flex flex-col sm:flex-row items-center justify-between gap-6 shadow-md">
            <div>
              <h3 className="text-xl font-bold text-sand-50">Vil du høre mere om hovtrim til din hest?</h3>
              <p className="text-sm text-sand-200 mt-1">Jeg kører i hele Jylland og svarer gerne på spørgsmål.</p>
            </div>
            <Link
              to="/kontakt"
              className="px-6 py-3 bg-forest-700 hover:bg-forest-600 text-white font-bold text-sm rounded-xl transition-colors cursor-pointer shrink-0"
            >
              Kontakt Hoofcare
            </Link>
          </div>

        </div>
      </section>
    </>
  );
}
